import {
	Component,
	OnInit,
	Renderer2,
	Inject,
	PLATFORM_ID,
	HostListener,
	ElementRef,
	ViewChild,
} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import {
	FormControl,
	FormGroup,
	FormBuilder,
	Validators,
} from '@angular/forms';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

// Services
import { TestimonialService } from '../providers/testimonial/testimonial.service';
import { PageService } from '../providers/page/page.service';
import { BlogService } from '../providers/blog/blog.service';
import 'lazysizes';

import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ProjectService } from '../providers/project/project.service';
import {
	ModalDismissReasons,
	NgbDatepickerModule,
	NgbModal,
	NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';

import { SpinalThreeService } from '../providers/SplineThree/spinal-three.service';

export interface PhotosApi {
	albumId?: number;
	id?: number;
	title?: string;
	url?: string;
	thumbnailUrl?: string;
}

declare const google: any;

@Component({
	selector: 'app-demo-case-study',
	templateUrl: './demo-case-study.component.html',
	styleUrls: ['./demo-case-study.component.scss'],
})
export class DemoCaseStudyComponent {
	@ViewChild('myVideo') videoElement!: ElementRef;
	containerRef!: ElementRef<HTMLDivElement>;
	apiData: PhotosApi;
	limit: number = 10; // <==== Edit this number to limit API results
	baseUrl: any;
	Url: any;
	slides: any = [];
	recentslider: any = [];
	customOptions: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		margin: 14,
		responsive: {
			0: {
				items: 3,
			},
			400: {
				items: 4,
			},
			740: {
				items: 8,
			},
			940: {
				items: 10,
			},
		},
		nav: false,
	};

	// recent work slider
	recentoptions: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		margin: 14,
		responsive: {
			0: {
				items: 2,
			},
			480: {
				items: 2,
			},
			740: {
				items: 3,
			},
			940: {
				items: 4,
			},
		},
		nav: false,
	};

	desktopslider: OwlOptions = {
		loop: false,
		rewind: true,
		autoplay: true,
		autoplayTimeout: 15000,
		center: true,
		dots: true,
		autoHeight: true,
		autoWidth: true,
		// animateOut: 'fadeOut',
		// animateIn: 'fadeIn',
		smartSpeed: 1,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 1,
			},
			1000: {
				items: 1,
			},
		},
	};
	// recent work slider

	page = 4;
	page1 = 5;
	focus;
	focus1;
	focus2;
	date: { year: number; month: number };
	model: NgbDateStruct;
	testimonialData: any;
	matchData: any;
	homeData: any;
	inviteData: any;
	mobile: any;
	invalidNumber: boolean = false;

	imagepath: any;
	isBrowser: boolean;
	emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
	// inviteForm: FormGroup;
	submitted = false;
	imageData: any = [
		{
			albumId: 1,
			id: 1,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: 'https://via.placeholder.com/600/92c952',
		},
		{
			albumId: 1,
			id: 2,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: 'https://via.placeholder.com/600/771796',
		},
	];
	currentPage: number = 1;
	allprojects: any = [];
	currentLimit: number = 4;
	public reviews = [];
	// recent work slider
	reviewSlider: OwlOptions = {
		items: 3,
		loop: true,
		margin: 20,
		autoplay: true,
		slideTransition: 'linear',
		// autoplayTimeout: 0,
		autoplaySpeed: 3000,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1,
			},
			480: {
				items: 1,
			},
			740: {
				items: 2,
			},
			991: {
				items: 3,
			},
		},
		dots: false,
		nav: false,
	};
	starRating = 4;
	instaLimit = 9;
	instagramPost = [];
	instagramProfile: any;
	searchText = '';
	closeResult = '';
	modalReference = null;
	selectedMedia: any;
	customMediaSlider: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: true,
		navSpeed: 700,
		navText: [
			'<i class="fas fa-arrow-left achprevious"></i>',
			'<i class="fas fa-arrow-right achnext active"></i>',
		],
		margin: 14,
		responsive: {
			0: {
				items: 1,
			},
			400: {
				items: 1,
			},
			740: {
				items: 1,
			},
			940: {
				items: 1,
			},
		},
		nav: false,
	};

	popupslider: OwlOptions = {
		loop: true,
		autoplay: false,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		navSpeed: 700,
		navText: [
			'<i class="fas fa-arrow-left achprevious"></i>',
			'<i class="fas fa-arrow-right achnext active"></i>',
		],
		margin: 14,
		responsive: {
			0: {
				items: 1,
			},
			400: {
				items: 1,
			},
			740: {
				items: 1,
			},
			940: {
				items: 1,
			},
		},
		nav: true,
	};
	isPlaying = true;
	spline: any;
	sectionWidth: number = 10; // Initial height
	intervalId: any;
	isChangingRandom = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(event: Event): void {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		// Adjust height and font size based on scroll position
		this.sectionWidth = Math.min(100, 50 + scrollTop / 10); // Max height: 100px
		if (this.spline) {
			this.spline.setZoom(1, 1);
		}
	}
	clientImgarray: any = [];
	filteredClients: any = [];
	constructor(
		private renderer: Renderer2,
		@Inject(PLATFORM_ID) private _platformId: Object,
		private testimonialService: TestimonialService,
		private pageservice: PageService,
		private metaTagService: Meta,
		private titleService: Title,
		private splineThreeService: SpinalThreeService,
		private formBuilder: FormBuilder,
		private readonly http: HttpClient,
		private projectservice: ProjectService,
		private modalService: NgbModal,
		private activeModal: NgbActiveModal
	) {
		this.imagepath = environment.backendUrl + '/public/';
		this.baseUrl = environment.baseUrl + '/assets';
		this.get_PageMeta();
		this.get_AllProjects();
		// this.getInstagramPosts();
		this.slides.push(
			{ id: 1, img: this.baseUrl + '/img/home/veritcal-images/1.jpg' },
			{ id: 2, img: this.baseUrl + '/img/home/veritcal-images/2.jpg' },
			{ id: 3, img: this.baseUrl + '/img/home/veritcal-images/3.jpg' },
			{ id: 4, img: this.baseUrl + '/img/home/veritcal-images/4.jpg' },
			{ id: 5, img: this.baseUrl + '/img/home/veritcal-images/5.jpg' },
			{ id: 6, img: this.baseUrl + '/img/home/veritcal-images/6.jpg' },
			{ id: 7, img: this.baseUrl + '/img/home/veritcal-images/7.jpg' },
			{ id: 8, img: this.baseUrl + '/img/home/veritcal-images/8.jpg' },
			{ id: 9, img: this.baseUrl + '/img/home/veritcal-images/9.jpg' },
			{ id: 10, img: this.baseUrl + '/img/home/veritcal-images/10.jpg' }
		);
		this.recentslider.push(
			{
				id: 1,
				img: this.baseUrl + '/img/home/beyou.webp',
				brandname: 'BeYou',
				brandtag: 'Branding.UI/UX.Technology',
			},
			{
				id: 2,
				img: this.baseUrl + '/img/home/cups.webp',
				brandname: 'BeYou',
				brandtag: 'Branding.UI/UX.Technology',
			},
			{
				id: 3,
				img: this.baseUrl + '/img/home/bcard22.webp',
				brandname: 'BeYou',
				brandtag: 'Branding.UI/UX.Technology',
			},
			{
				id: 4,
				img: this.baseUrl + '/img/home/vendetta2.webp',
				brandname: 'BeYou',
				brandtag: 'Branding.UI/UX.Technology',
			}
		);
		this.clientImgarray.push(
			{ id: 1, img: this.baseUrl + '/img/home/logos/dnour.svg', class: '' },
			{ id: 2, img: this.baseUrl + '/img/home/logos/crystal.svg', class: '' },
			{ id: 3, img: this.baseUrl + '/img/home/logos/miniaar.svg', class: '' },
			{ id: 4, img: this.baseUrl + '/img/home/logos/bni.svg', class: '' },
			{ id: 5, img: this.baseUrl + '/img/home/logos/angle.svg' },
			{ id: 6, img: this.baseUrl + '/img/home/logos/pakhis.svg', class: '' },
			{ id: 7, img: this.baseUrl + '/img/home/logos/drminnie.svg', class: '' },
			{ id: 8, img: this.baseUrl + '/img/home/logos/veddentta.svg', class: '' },
			{
				id: 9,
				img: this.baseUrl + '/img/home/logos/autokoorosh.svg',
				class: '',
			},
			{ id: 10, img: this.baseUrl + '/img/home/logos/fractal.svg', class: '' },
			{
				id: 11,
				img: this.baseUrl + '/img/home/logos/corporate.svg',
				class: '',
			},
			{ id: 12, img: this.baseUrl + '/img/home/logos/aetrio.svg', class: '' },
			{ id: 13, img: this.baseUrl + '/img/home/logos/wrae.svg', class: '' },
			{ id: 14, img: this.baseUrl + '/img/home/logos/beyou.svg', class: '' },
			{
				id: 15,
				img: this.baseUrl + '/img/home/logos/alchemative.svg',
				class: '',
			},
			{ id: 16, img: this.baseUrl + '/img/home/logos/Asset 13.svg', class: '' },
			{
				id: 17,
				img: this.baseUrl + '/img/home/logos/caratcraft.svg',
				class: '',
			},
			{ id: 18, img: this.baseUrl + '/img/home/logos/ep.svg', class: '' },
			{
				id: 19,
				img: this.baseUrl + '/img/home/logos/holidaymate.svg',
				class: '',
			},
			{ id: 20, img: this.baseUrl + '/img/home/logos/j.avenue.svg', class: '' },
			// { id: 21, img: this.baseUrl + "/img/home/logos/jwarashri.svg", class:'' },
			{
				id: 22,
				img: this.baseUrl + '/img/home/logos/maney-angel.svg',
				class: '',
			},
			{
				id: 23,
				img: this.baseUrl + '/img/home/logos/santosh-kotli.svg',
				class: '',
			},
			{
				id: 24,
				img: this.baseUrl + '/img/home/logos/solitaire-events.svg',
				class: '',
			},
			{ id: 25, img: this.baseUrl + '/img/home/logos/spacex.svg', class: '' },
			{
				id: 26,
				img: this.baseUrl + '/img/home/logos/urban-excellence.svg',
				class: '',
			},
			{
				id: 27,
				img: this.baseUrl + '/img/home/logos/virtual-key.svg',
				class: '',
			},
			{ id: 28, img: this.baseUrl + '/img/home/logos/zlk.svg', class: '' }
		);
		this.filteredClients = this.clientImgarray.slice(0, 15);
	}

	onHover() {
		if (!this.isChangingRandom) {
			this.isChangingRandom = true;
			this.intervalId = setInterval(() => {
				this.filterClients();
			}, 2000);
		}
	}

	filterClients() {
		this.filteredClients.forEach((cl) => {
			cl.class = '';
		});
		let notvisibleClients = this.clientImgarray;
		let randomClients = [];
		for (var i = 0; i < 2; i++) {
			var idx = Math.floor(Math.random() * notvisibleClients.length);
			let tempRandom = randomClients.filter((cl) => cl.id == idx);
			if (tempRandom.length == 0) {
				randomClients.push(notvisibleClients[idx]);
			}
		}
		for (var j = 0; j < randomClients.length; j++) {
			let tempRandom = this.filteredClients.filter(
				(cl) => cl.id == randomClients[j].id
			);
			if (tempRandom.length == 0) {
				var idy = Math.floor(Math.random() * this.filteredClients.length);
				this.filteredClients[idy] = randomClients[j];
				this.filteredClients[idy].class = 'blur';
			}
		}
	}

	isWeekend(date: NgbDateStruct) {
		const d = new Date(date.year, date.month - 1, date.day);
		return d.getDay() === 0 || d.getDay() === 6;
	}

	isDisabled(date: NgbDateStruct, current: { month: number }) {
		return date.month !== current.month;
	}

	ngOnInit() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		this.fetch();
		let input_group_focus = document.getElementsByClassName('form-control');
		let input_group = document.getElementsByClassName('input-group');
		for (let i = 0; i < input_group.length; i++) {
			input_group[i].children[0].addEventListener('focus', function () {
				input_group[i].classList.add('input-group-focus');
			});
			input_group[i].children[0].addEventListener('blur', function () {
				input_group[i].classList.remove('input-group-focus');
			});
		}
		$('li').removeClass('main-menu__item--active');
		$('#home').addClass('main-menu__item--active');
		window.scroll(0,0);
		
		const request = {
			placeId: 'ChIJV7cSUslDXz4R9uz8yYTtshE',
			fields: ['reviews'],
		};
		this.onHover();
		
		// }
	}

	get_PageMeta() {
		let obj = { pageName: 'home' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.code == 200) {
				this.titleService.setTitle(response?.body.result.meta_title);
				this.metaTagService.updateTag({
					name: 'description',
					content: response?.body.result.meta_description,
				});
				this.metaTagService.updateTag({
					name: 'keywords',
					content: response?.body.result.meta_keywords,
				});
				this.metaTagService.updateTag({
					rel: 'canonical',
					href: 'https://www.pixtar.ae/home',
				});
			} else if (response.code == 400) {
			} else {
			}
		});
	}

	fetch() {
		const api = `https://jsonplaceholder.typicode.com/albums/1/photos?_start=0&_limit=${this.limit}`;
		const http$ = this.http.get<PhotosApi>(api);

		http$.subscribe(
			(res) => (this.apiData = res),
			(err) => throwError(err)
		);
	}

	get_AllProjects() {
		const obj = {
			limit: this.currentLimit,
			page: this.currentPage,
		};
		this.projectservice.getAllProjects(obj).subscribe((response) => {
			if (response.code == 200) {
				if (response.result && response.result.length > 0) {
					response.result.forEach((project) => {
						if (project.status) {
							this.allprojects.push(project);
						}
					});
				}
			} else if (response.code == 400) {
			} else {
			}
		});
	}

	loadMore() {
		this.currentLimit = this.currentLimit + 4;
		this.get_AllProjects();
	}

	// ngAfterViewInit() {

	// }

	public callback = (place, status) => {
		if (status === google.maps.places.PlacesServiceStatus.OK) {
			this.reviews = place.reviews.slice();
		}
	};

	createRange(number) {
		const items: number[] = [];
		for (let i = 1; i <= number; i++) {
			items.push(i);
		}
		return items;
	}

	getInstagramPosts() {
		let obj = { limit: this.instaLimit };
		this.pageservice.getInstagramPosts(obj).subscribe((response) => {
			if (response.code == 200) {
				this.instagramPost = response.result;
				this.instagramProfile = response.profile;
			} else if (response.code == 400) {
			} else {
			}
		});
	}

	loadmorePost() {
		this.instaLimit = this.instaLimit + 9;
		this.getInstagramPosts();
	}

	openCarasoulpopup(instamedia, data) {
		this.selectedMedia = data;
		if (data.media_type == 'CAROUSEL_ALBUM') {
			this.modalReference = this.modalService
				.open(instamedia, {
					ariaLabelledBy: 'modal-basic-title',
					windowClass: 'myCustomModalClass',
					size: 'lg',
					backdrop: 'static',
				})
				.result.then(
					(result) => {
						this.closeResult = `Closed with: ${result}`;
					},
					(reason) => {
						this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
					}
				);
		}
	}

	openPopup(instamedia) {
		this.modalReference = this.modalService
			.open(instamedia, {
				ariaLabelledBy: 'modal-basic-title',
				windowClass: 'myCustomModalClass-video',
				size: 'lg',
				backdrop: 'static',
			})
			.result.then(
				(result) => {
					this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
				}
			);
	}

	openMediaPopup(instamedia, data) {
		this.selectedMedia = data;
		this.modalReference = this.modalService
			.open(instamedia, {
				ariaLabelledBy: 'modal-basic-title',
				windowClass: 'myCustomModalClass',
				size: 'lg',
				backdrop: 'static',
			})
			.result.then(
				(result) => {
					this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
				}
			);
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	closeModal() {
		this.activeModal.close();
	}

	makeLinksClickable(caption) {
		if (caption) {
			let lines = caption.split('\n');
			lines = lines.map((line) => {
				if (line.includes('#')) {
					let splitedLine = line.split(' ');
					line = splitedLine
						.map(
							(linkData) =>
								`<a href="https://instagram.com/explore/tags/${
									linkData.split('#')[1]
								}" target="_blank">${linkData}</a>`
						)
						.join('');
				}
				return line;
			});
			return lines.map((line) => `${line}</br>`).join('');
		}
	}

	sliderInterval: any;
	stopSlider(): void {
		if (this.sliderInterval) {
			clearInterval(this.sliderInterval); // Clears the interval
			// console.log('Slider stopped');
		}
	}

	onMouseLeave() {
		// clearInterval(this.interval);
		if (this.sliderInterval) {
			clearInterval(this.sliderInterval); // Clears the interval
			console.log('Slider stopped');
		}
	}

	onMouseEnter(index: number): void {
		let projectname = this.allprojects[index];
		let images = projectname.project_images;
		let url = this.imagepath;
		let img = document.getElementsByClassName('galleryimg' + index);

		// Function to update the images
		this.sliderInterval = setInterval(() => {
			// setInterval(function () {
			$(img).each(function (index) {
				let newImage =
					images[
						(index + Math.floor(Math.random() * images.length)) % images.length
					];
				$(img).attr('src', url + newImage); // Set new image source
			});
		}, 900); // Update every 3 seconds
		// console.log(`Mouse entered image at index: ${index}`);
	}

	ngAfterViewInit() {
		const elem = this.videoElement.nativeElement;
		elem.muted = true; // Ensure the video is muted for autoplay compatibility
		elem.loop = true;

		// Attempt to autoplay the video when the component initializes
		elem.play().catch((err) => {
			console.log('Autoplay failed, user interaction may be required:', err);
		});

		if (!this.sliderRef || !this.handleRef) {
			console.error('Slider references not found!');
		}
	}

	playInFullscreenWithAudio() {
		const elem = this.videoElement.nativeElement;

		// Unmute the video
		elem.muted = false;
		elem.loop = true;

		// Remove controls to avoid interference in fullscreen mode
		elem.removeAttribute('controls');

		// Attempt to play the video and request fullscreen
		elem
			.play()
			.then(() => {
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.webkitRequestFullscreen) {
					// Safari
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					// IE11
					elem.msRequestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					// Firefox
					elem.mozRequestFullScreen();
				}
			})
			.catch((err) => {
				console.log('Error entering fullscreen with audio: ', err);
			});
	}

	@HostListener('document:fullscreenchange', ['$event'])
	onFullscreenChange() {
		const elem = this.videoElement.nativeElement;

		if (
			document.fullscreenElement === elem ||
			(document as any).webkitFullscreenElement === elem ||
			(document as any).msFullscreenElement === elem ||
			(document as any).mozFullScreenElement === elem
		) {
			// Video is in fullscreen, attempt to play
			elem.play().catch((err) => {
				console.log('Could not play in fullscreen mode:', err);
			});
		} else {
			// Video exited fullscreen, restore controls and mute the video
			elem.setAttribute('controls', '');
			elem.muted = true;
		}
	}

	beforeImage = 'http://i.imgur.com/BIHN8KQ.jpg';
	afterImage = 'http://i.imgur.com/nS6dvpq.jpg';
	beforeAlt = 'Before';
	afterAlt = 'After';

	dragging = false;
	sliderPosition = 50;

	@ViewChild('sliderRef', { static: false }) sliderRef!: ElementRef;
	@ViewChild('handleRef', { static: false }) handleRef!: ElementRef;

	onMouseDown(event: MouseEvent | TouchEvent) {
		event.preventDefault();
		this.dragging = true;
	}

	@HostListener('document:mouseup')
	@HostListener('document:touchend')
	onMouseUp() {
		this.dragging = false;
	}

	adjustSlider() {
		this.sliderPosition = 50; // Reset position after images load
	}

	@HostListener('document:mousemove', ['$event'])
	@HostListener('document:touchmove', ['$event'])
	onMouseMove(event: MouseEvent | TouchEvent) {
		if (!this.dragging) return;

		const container = this.sliderRef.nativeElement;
		const pageX =
			(event as TouchEvent).touches?.[0]?.pageX || (event as MouseEvent).pageX;
		const containerRect = container.getBoundingClientRect();

		let position = ((pageX - containerRect.left) / containerRect.width) * 100;
		this.sliderPosition = Math.max(0, Math.min(100, position));
	}
}
